// extracted by mini-css-extract-plugin
module.exports = {"note":"NotaVerOrden_note__1iq7E"};